/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type CategoryEdit_category$ref = any;
export type CategoryEditQueryVariables = {|
  categoryId: string
|};
export type CategoryEditQueryResponse = {|
  +category: ?{|
    +$fragmentRefs: CategoryEdit_category$ref
  |}
|};
export type CategoryEditQuery = {|
  variables: CategoryEditQueryVariables,
  response: CategoryEditQueryResponse,
|};
*/


/*
query CategoryEditQuery(
  $categoryId: ID!
) {
  category(id: $categoryId) {
    ...CategoryEdit_category
    id
  }
}

fragment CategoryEdit_category on Category {
  id
  name
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "categoryId",
    "type": "ID!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "categoryId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CategoryEditQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Category",
        "kind": "LinkedField",
        "name": "category",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CategoryEdit_category"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CategoryEditQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Category",
        "kind": "LinkedField",
        "name": "category",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "CategoryEditQuery",
    "operationKind": "query",
    "text": "query CategoryEditQuery(\n  $categoryId: ID!\n) {\n  category(id: $categoryId) {\n    ...CategoryEdit_category\n    id\n  }\n}\n\nfragment CategoryEdit_category on Category {\n  id\n  name\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '54c5633903594442a8da8d33af651f74';

module.exports = node;
